// zone.js flags. MUST be imported BEFORE `import 'zone.js'` in polyfills.ts
// (import hoisting means a plain statement in polyfills.ts would run too late).
// Same flags as the frontend app.
//
// Do not patch MutationObserver / IntersectionObserver: when the class has already
// been wrapped by someone else (a browser extension, or another zone.js copy), zone's
// patchClass recurses through `originalInstanceKey` and throws
// `RangeError: Maximum call stack size exceeded`. Quill (dx-html-editor) uses
// MutationObserver and Google Maps uses IntersectionObserver. Angular's change
// detection does not depend on either patch.
(window as any).__Zone_disable_MutationObserver = true;
(window as any).__Zone_disable_IntersectionObserver = true;
